import { useEffect, useState } from "react"

import { FIT_TO_BOUNDING_BOX_DURATION, MAP_TYPE_NETWORK, useMapContext } from "@l2r-front/l2r-map"

import { useNetworksStateContext } from "../../contexts/NetworksContext"

type MapAdapterBoundingBoxProps = {
    module: string
}

export const MapAdapterBoundingBox = (props: MapAdapterBoundingBoxProps) => {

    const { module } = props

    const { getSelectedNetworkBoundingBox } = useNetworksStateContext()
    const [mapState, mapDispatch] = useMapContext()
    const { storedBoundingBox } = mapState
    const { getMapRef, setMapType, setMapBoundingBoxToFit, restoreMapBoundingBox } = mapDispatch
    const mapRef = getMapRef()
    const [isBBSet, setIsBBSet] = useState(false)

    useEffect(() => {
        setMapType(MAP_TYPE_NETWORK)
    }, [setMapType])

    useEffect(() => {
        if (mapRef && !isBBSet && module) {
            if (storedBoundingBox.network) {
                setIsBBSet(true)
                restoreMapBoundingBox(MAP_TYPE_NETWORK, { duration: FIT_TO_BOUNDING_BOX_DURATION })
            } else {
                const [minLng, minLat, maxLng, maxLat] = getSelectedNetworkBoundingBox(module)
                if (minLng === Infinity || minLat === Infinity || maxLng === -Infinity || maxLat === -Infinity) {
                    return
                }
                setIsBBSet(true)
                setMapBoundingBoxToFit({
                    minLng,
                    minLat,
                    maxLng,
                    maxLat,
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isBBSet, mapRef, getSelectedNetworkBoundingBox])

    return null
}